import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import './shared/forms/YupPortugueseTranslation';
import { AppRoutes } from './routes';
import { LoginPage } from './shared/components';
import { AppointmentProvider, AppThemeProvider, BusinessProvider, LoadingProvider, MenuProvider, useUserContext, UserProvider } from './shared/contexts';
import { PushNotificationProvider } from './shared/contexts/PushNotificationContext';
import { queryClient } from './shared/services/queryClient';

dayjs.locale('pt-br');
dayjs.extend(customParseFormat);

/** Componente interno que depende do UserProvider (auth). */
const AppInner = () => {
  const { isAuthenticated } = useUserContext();

  return (
    <PushNotificationProvider isAuthenticated={isAuthenticated}>
      <AppThemeProvider>
        <LoadingProvider>
          <LoginPage>
            <BusinessProvider>
              <AppointmentProvider>
                <MenuProvider>
                  <AppRoutes />
                </MenuProvider>
              </AppointmentProvider>
            </BusinessProvider>
          </LoginPage>
        </LoadingProvider>
      </AppThemeProvider>
    </PushNotificationProvider>
  );
};

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='pt-br'>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
          <BrowserRouter>
            <UserProvider>
              <AppInner />
            </UserProvider>
          </BrowserRouter>
        </GoogleOAuthProvider>
      </LocalizationProvider>
    </QueryClientProvider>
  );
};
